import { gql } from 'graphql-request'
import { DynamicBlockZone } from '../../../lib/strapi/dynamicBlockZones'
import { TextInputFragment, TextInputZoneType } from './TextInputZone'
import { TextBlock } from '../../TextBlock'
import { PowDynamicFormData, PowDynamicForm } from '../../PowDynamicForm'
import { SelectInputFragment, SelectInputZoneType } from './SelectInputZone'

export type PowDynamicFormZoneInputType =
  TextInputZoneType | SelectInputZoneType

export type PowDynamicFormZoneType = DynamicBlockZone<
  'ComponentFormPowDynamicForm',
  {
    form: PowDynamicFormData
  }
>

export const PowDynamicFormZoneFragment = gql`
...on ComponentFormPowDynamicForm {
  __typename
  form {
    data {
      attributes {
        title
        description
        inputFields {
          __typename
          ${TextInputFragment}
          ${SelectInputFragment}
        }
        hCaptcha
        submitButtonText
        formId
      }
    }
  }
}
`

function PowDynamicFormZone(props: PowDynamicFormZoneType) {
  return (
    <TextBlock>
      <PowDynamicForm data={props.form.data} />
    </TextBlock>
  )
}

export { PowDynamicFormZone as default }
